module.exports = __webpack_public_path__ + "static/generaltire-18d4d8a322dfa1d54e9f6d09131787bc.png";